import { createTheme  as createMuiTheme } from '@material-ui/core/styles';
import config from 'shared/config';
import { indigo } from '@material-ui/core/colors';

// adjust theme colors using client customization settings or default to storis colors
const primary = config.COLORS.Primary !== '' ? config.COLORS.Primary : indigo[500];

/**
 * create theme, override default palette and specify some constants from the material design spec
 * - palette defaults are:
 *   - primary = indigo
 *   - secondary = pink
 *   - error = red
 *   - type = 'light'
 * - breakpoints can be overridden
 * - typography can be overridden
 * - mixins can be added (for recurring style rules)
 * - anything else added, like the components object defined below, is added to the theme
 */
const theme = createMuiTheme({
	palette: {
		primary: {
			main: primary,
		},
	},
});

export default theme;
